/*
 *
 * File: passenger_reducer.js
 *
 * Purpose: Passenger data reducer.
 *
 * Author:  Thomas Burgard (Software development)
 * Created: 14.04.2023
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { GET_PASSENGERDATA, CLEAR_USERDATA_IN_STATE } from "../types";
import { getUserFromLocalStorage, addUserToLocalStorage } from "../../utils/localStorage";

const initialState = {
  userData: getUserFromLocalStorage(), // username of passenger!
  passengerData: {
    Success: false,
    PassengerData: "Initial",
  },
};

/**
 * Passenger data reducer function.
 * 
 * @param {*} state Redux state as app wide store (initial state is empty)
 * @param {*} action which action is then processing
 * @returns state
 */
export default function passengerReducer(state = initialState, action) {
  switch (action.type) {
    // Get user data from Server
    case GET_PASSENGERDATA:
      if (action.payload.passengerData.Success) {
        // Store user data in local storage
        addUserToLocalStorage(action.payload);
        state.userData = action.payload.username;
      } 
      
      return { ...state, ...action.payload };
    case CLEAR_USERDATA_IN_STATE:
      state.userData = null;
      state.passengerID = null;
      state.passengerData.Success = false;
      state.passengerData.PassengerData = "initial";
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
